import { CurrencyAmount, Token } from '@uniswap/sdk-core'
import useActiveWeb3 from 'hooks/blockchain/useActiveWeb3'
import { useTokenBalances } from 'hooks/tokens/useCurrencyBalance'
import { useMemo } from 'react'

import { useAllTokens } from '../../hooks/tokens/Tokens'

export {
  default as useCurrencyBalance,
  useCurrencyBalances,
  useNativeCurrencyBalances,
  useTokenBalance,
  useTokenBalances,
  useTokenBalancesWithLoadingIndicator,
} from 'hooks/tokens/useCurrencyBalance'

// mimics useAllBalances
export function useAllTokenBalances(): { [tokenAddress: string]: CurrencyAmount<Token> | undefined } {
  const { account } = useActiveWeb3()
  const allTokens = useAllTokens()
  const allTokensArray = useMemo(() => Object.values(allTokens ?? {}), [allTokens])
  const balances = useTokenBalances(account ?? undefined, allTokensArray)
  return balances ?? {}
}
